// extracted by mini-css-extract-plugin
export var backdropBlur = "_lp-0";
export var contentCard = "_lp-5";
export var frame = "_lp-2";
export var image = "_lp-4";
export var imagePane = "_lp-3";
export var modal = "_lp-1";